module.exports = __webpack_public_path__ + "img/mycoach.ad8bede2.svg";